import * as React from "react";
const SvgFiRrWomanScientist = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-woman-scientist_svg__a)">
      <path
        fill="#062147"
        d="M23.383 20.019 20 16.509V14a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2v2.51l-3.455 3.594a2.36 2.36 0 0 0-.314 2.53A2.36 2.36 0 0 0 15.387 24h6.227c.956 0 1.791-.543 2.179-1.416a2.36 2.36 0 0 0-.409-2.565zm-1.419 1.753a.37.37 0 0 1-.351.229h-6.227a.37.37 0 0 1-.348-.22c-.038-.082-.083-.244 0-.349l3.462-3.598 3.406 3.534a.37.37 0 0 1 .058.404m-8.576-5.352a8 8 0 0 0-.483-.343.29.29 0 0 0-.376.063l-2.743 3.479c-.379.48-1.191.48-1.57 0l-2.76-3.499c-.077-.09-.241-.118-.36-.044a8 8 0 0 0-.786.592c-1.467 1.271-2.309 3.247-2.309 5.423V23a1 1 0 1 1-2 0v-.909c0-2.757 1.094-5.284 3-6.935q.468-.405 1.002-.755a2.294 2.294 0 0 1 3.006.458l1.992 2.525 1.975-2.504c.761-.912 2.054-1.111 3.02-.48q.32.207.618.439a1 1 0 0 1 .178 1.402.995.995 0 0 1-1.402.178zM1.616 14.025q.116.027.23.026c.453 0 .863-.311.973-.771.293-1.242.666-2.814 1.01-4.253A6 6 0 0 0 9 11.998a6 6 0 0 0 3.001-.804.997.997 0 0 0 .364-1.366.997.997 0 0 0-1.366-.364A4 4 0 0 1 9 9.998c-1.862 0-3.417-1.284-3.861-3.009.056.001.112.01.167.01a6.7 6.7 0 0 0 3.546-1.021 6.66 6.66 0 0 0 2.669-3.185 4.4 4.4 0 0 1 1.676 2.257c.043.137.264.991 1.261 5.18a1 1 0 0 0 1.945-.462c-1.036-4.354-1.24-5.14-1.304-5.332a6.39 6.39 0 0 0-6.1-4.437A6.39 6.39 0 0 0 2.9 4.437c-.174.537-1.72 7.079-2.028 8.386a1 1 0 0 0 .744 1.203zM9 2c.223 0 .442.02.657.052a4.67 4.67 0 0 1-1.863 2.231 4.67 4.67 0 0 1-2.952.674A4.39 4.39 0 0 1 9 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-woman-scientist_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWomanScientist;
